import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { confetti } from "../../utils/confetti.js";
import CopyLinkIcon from "../../assets/images/copylink.svg";
import CheckIcon from "../../assets/images/check.svg";
import FbIcon from "../../assets/images/fb.svg";
import TwitterIcon from "../../assets/images/twitter.svg";
import CalendarIcon from "../../assets/images/calendar.svg";
import CloseImage from "../../assets/images/close-white.svg";
import NBAIDLogo from "../../assets/images/NBAID.svg";
import "../../assets/css/challenges.css";

function ChallengeModal() {
    const selectedChallenge = useSelector(state => state.data.selectedChallenge);
    const getLatestAwardedActivity = () => {
        if (selectedChallenge && selectedChallenge.activities && selectedChallenge.activities.length > 0) {
            let latest;
            for(let act of selectedChallenge.activities) {
                if (act.activityHistory && act.activityHistory.length > 0) {
                    if (latest && latest.date_awarded) {
                        if (act.activityHistory[0].date_awarded) {
                            latest = act.activityHistory[0].date_awarded > latest.date_awarded ?
                                act.activityHistory[0] : latest;
                        }
                    } else {
                        latest = {...act.activityHistory[0]};
                    }
                }
            }
            if(latest) {
                return <span style={{ fontWeight: "900", color: "#4E525C" }}>
                    {` ${new Intl.DateTimeFormat("en-US", { weekday: "long" }).format(latest.date_awarded * 1000)}, `}
                    {`${new Intl.DateTimeFormat("en-US", { month: "long" }).format(latest.date_awarded * 1000)}
                    ${(new Date(latest.date_awarded * 1000)).getDate()},
                    ${(new Date(latest.date_awarded * 1000)).getFullYear()}`}.
                </span>
            }
        }
    };
    const [linkCopied, setLinkCopied] = useState(false);
    const [modalBackgroundSize, setModalBackgroundSize] = useState(270);

    // Modal Analytics
    useEffect(() => {
        if (window._satellite && window._satellite.track) {
            if (selectedChallenge) {
                let data = {
                    modalName: "nba:membership-hub:challenge-detail",
                    contentTitle: selectedChallenge.title,
                    contentID: selectedChallenge.id,
                    contentType: "Challenge",
                };
                window._satellite.track("modal-display", data);
            }
        }
        console.log("Challenge Modal: analytics added");

        if (selectedChallenge) {
            const confettiShown = JSON.parse(localStorage.getItem("confetti-challenge")) ?? [];
            console.log("confettiShown challenge:", confettiShown);

            if (!confettiShown.includes(String(selectedChallenge.id))) {
                confetti.start();

                confettiShown.push(String(selectedChallenge.id));
                localStorage.setItem("confetti-challenge", JSON.stringify(confettiShown));

                setTimeout(function () {
                    confetti.stop();
                }, 5000);
            }
        }
    }, [selectedChallenge]);

    useEffect(() => {
        const onResize = () => {
            const rect = document.getElementsByClassName("challenge-modal-info")[0].getBoundingClientRect();
            if (window.innerWidth > 768) {
                setModalBackgroundSize(270);
            } else {
                setModalBackgroundSize(rect.top + (rect.height / 2));
            }
        };
        onResize();
        window.addEventListener("resize", onResize);
        return () => {
            window.removeEventListener("resize", onResize);
        }
    }, []);

    const shareOnSocial = (e, socialType) => {
        e.preventDefault();

        const shareUrl = `${window.location.origin}/api/meta/challenges/${selectedChallenge.id}`;
        console.log("shareUrl:", shareUrl);

        let shareText = (selectedChallenge.extra_data && selectedChallenge.extra_data.SocialShare_copy) ? selectedChallenge.extra_data.SocialShare_copy : "";
        console.log("shareText:", shareText);

        let url = "";

        if (socialType === "copy") {
            navigator.clipboard.writeText(shareUrl);
            setLinkCopied(true);
        }
        else if (socialType === "facebook") {
            url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&quote=${encodeURIComponent(shareText)}`;
        }
        else if (socialType === "twitter") {
            url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`;
        }

        if (url) {
            console.log("url:", url);
            let shareWidth = 520;
            let shareHeight = 570;
            let shareLeft = (window.screen.width - shareWidth) / 2;
            let shareTop = (window.screen.height - shareHeight) / 2;
            window.open(url, "_blank", `location=yes,height=${shareHeight},width=${shareWidth},left=${shareLeft},top=${shareTop},scrollbars=yes,status=yes`);
        }
    };

    return (
        <div className="modal-container">
            <div className="close">
                <Link to={{
                        pathname: "/challenges",
                        search: window.location.search.includes("cl=1") ? window.location.search.replace("&cl=1", "") : window.location.search
                    }}>
                    <img
                        alt="close"
                        className="cursor-pointer"
                        style={{
                            width: "16px",
                            height: "16px",
                            float: "right",
                            margin: "16px",
                        }}
                        src={CloseImage}
                    />
                </Link>
            </div>
            <div className="challenge-modal" style={{backgroundImage: `url(${selectedChallenge.extra_data.BackgroundImage})`, backgroundSize: `100% ${modalBackgroundSize}px` }}>
                <div className="nba-id-logo"><img src={NBAIDLogo} /></div>
                <div className="challenge-modal-header">
                    <div className="challenge-basics">
                        <div className="image">
                            <img src={selectedChallenge.image} />
                        </div>
                        <div className="challenge-desc">
                            <p className="title">
                                {selectedChallenge && selectedChallenge.title}
                            </p>
                            <p className="description"
                                dangerouslySetInnerHTML={{ __html: (selectedChallenge && selectedChallenge.description ? selectedChallenge.description : "")}}>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="challenge-modal-info">
                    <div className="challenge-completion">
                        Track Your Progress
                    </div>
                    <div className="challenge-progress">
                        <div className="percent-completed" style={{width: "100%"}}>100%</div>
                    </div>
                    <div className="challenge-modal-congrats">
                        {`You earned this badge on `}
                        { getLatestAwardedActivity() }
                    </div>
                </div>
                <div className="challenge-modal-date">  
                    <div className="challenge-date-container">
                        <div className="challenge-date-header">Challenge Dates</div>
                        <div className="challenge-date">
                            <img src={CalendarIcon} alt="" />
                            {new Intl.DateTimeFormat("en-US", { month: "long" }).format(selectedChallenge.date_start * 1000)}&nbsp;
                            {new Date(selectedChallenge.date_start * 1000).getDate()},&nbsp;
                            {new Date(selectedChallenge.date_start * 1000).getFullYear()}&nbsp;
                            - {new Intl.DateTimeFormat("en-US", { month: "long" }).format(selectedChallenge.date_end * 1000)}&nbsp;
                            {new Date(selectedChallenge.date_end * 1000).getDate()},&nbsp;
                            {new Date(selectedChallenge.date_end * 1000).getFullYear()}&nbsp;
                        </div>
                    </div>
                    <div className="presented-by">
                        { selectedChallenge.extra_data.Partner_logo &&
                            <>
                                Presented by
                                <img className="sponsor-logo" src={selectedChallenge.extra_data.Partner_logo}/>
                            </>
                        }
                    </div>
                </div>
                <div className="challenge-modal-share">
                    <div className="share-header">Share Your Badge</div>
                    <div className="share-subheader">Congrats on earning this badge. Share it with the world.</div>
                    <div className="challenge-modal-share-container">
                        <Link
                            to={{ pathname: `/challenges/${selectedChallenge.id}`, search: window.location.search }}
                            reloadDocument="false"
                            data-track="click"
                            data-id="nba:membership-hub:social"
                            data-section="challenges"
                            data-content="CopyLink"
                            data-type="social"
                            className="share-button" title="Copy Link" onClick={(e) => shareOnSocial(e, "copy")}>
                            {linkCopied ?
                                <>
                                    <div className="icon-container link-copied">
                                        <img src={CheckIcon} alt="Link Copied" className="challenge-modal-share-icon" />
                                    </div>
                                    <div className="site-name">Link Copied</div>
                                </>
                                :
                                <>
                                    <div className="icon-container">
                                        <img src={CopyLinkIcon} alt="Copy Link" className="challenge-modal-share-icon" />
                                    </div>
                                    <div className="site-name">Copy Link</div>
                                </>
                            }
                        </Link>
                        <Link
                            to={{ pathname: `/challenges/${selectedChallenge.id}`, search: window.location.search }}
                            reloadDocument="false"
                            data-track="click"
                            data-id="nba:membership-hub:social"
                            data-section="challenges"
                            data-content="Facebook"
                            data-type="social"
                            className="share-button" title="Share on Facebook" onClick={(e) => shareOnSocial(e, "facebook")}>
                            <div className="icon-container">
                                <img src={FbIcon} alt="Share on Facebook" className="challenge-modal-share-icon" />
                            </div>
                            <div className="site-name">Facebook</div>
                        </Link>
                        <Link
                            to={{ pathname: `/challenges/${selectedChallenge.id}`, search: window.location.search }}
                            reloadDocument="false"
                            data-track="click"
                            data-id="nba:membership-hub:social"
                            data-section="challenges"
                            data-content="Twitter"
                            data-type="social"
                            className="share-button" title="Share on Twitter" onClick={(e) => shareOnSocial(e, "twitter")}>
                            <div className="icon-container">
                                <img src={TwitterIcon} alt="Share on Twitter" className="challenge-modal-share-icon" />
                            </div>
                            <div className="site-name">X (Twitter)</div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default ChallengeModal;
